<template>
    <section class="result">
        <h1 class="result__title title title--h1">A je to! Vystavili jsme vám vyúčtování.</h1>
        <div class="result__container">
            <div class="result__top">
                <h3 class="result__subtitle result__subtitle--top">Vaše hodnocení </h3>
                <div class="result__badge">
                    <img :src="badge" alt="" class="result__badge__img">
                    <div class="result__badge__info">
                        <div class="result__badge__section">
                            <h3 class="result__badge__title result__badge__title--highlight">{{
                                    Math.floor(currentTotal)
                                }} litrů denně</h3>
                            <p class="result__text">vaše vodní stopa</p>
                        </div>
                        <div class="result__badge__section">
                            <h3 class="result__badge__title">4 500 litrů denně</h3>
                            <p class="result__text" v-html="'český celostátní průměr na&nbsp;1&nbsp;osobu'"></p>
                        </div>
                    </div>
                </div>
                <div class="result__social">
                    <h3 class="result__social__title" v-html="'Sdílejte kalkulačku vodní stopy s&nbsp;přáteli.'"></h3>
                    <ul class="result__social__list">
                        <li class="result__social__item">
                            <a href="http://www.linkedin.com/shareArticle?mini=true&url=http%3A%2F%2Fwww.voda.limited%2Fvodni-zuctovani&title=Kalkula%C4%8Dka%20vodn%C3%AD%20stopy&summary=&source=http%3A%2F%2Fwww.voda.limited%2Fvodni-zuctovani"
                               target="_blank"
                               title="LinkedIn"
                               class="result__social__btn result__social__btn--linkedin">LinkedIn</a>
                        </li>
                        <li class="result__social__item">
                            <a href="https://twitter.com/intent/tweet?source=http%3A%2F%2Fwww.voda.limited%2Fvodni-zuctovani&text=Kalkula%C4%8Dka%20vodn%C3%AD%20stopy:%20http%3A%2F%2Fwww.voda.limited%2Fvodni-zuctovani"
                               target="_blank"
                               title="Tweet"
                               class="result__social__btn result__social__btn--twitter">Twitter</a>
                        </li>
                        <li class="result__social__item">
                            <a href="https://www.facebook.com/sharer/sharer.php?u=http%3A%2F%2Fwww.voda.limited%2Fvodni-zuctovani&quote=Kalkula%C4%8Dka%20vodn%C3%AD%20stopy"
                               target="_blank"
                               title="Facebook"
                               class="result__social__btn result__social__btn--facebook">Facebook</a>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="result__bottom">
                <div class="result__bottom__section">
                    <h3 class="result__subtitle">Metodologie</h3>
                    <p class="result__text result__text--mb">Výsledek naší kalkulačky vám dá pouze hrubý přehled o tom,
                        kolik&nbsp;vody spotřebujete, závisí na&nbsp;tom totiž velké množství faktorů. Nechtěli jsme vás zahltit
                        otázkami, tak jsme vám položili jen ty základní. Pokud chcete spočítat svou vodní stopu ještě o
                        něco podrobněji, vyzkoušejte <a href="http://h2ospodar.cz/kalkulacka/"
                                                        target="_blank"
                                                        class="result__link"><b>tuto kalkulačku.</b></a></p>
                    <p class="result__text">
                        <span v-html="'S výpočty pro kalkulačku vodní stopy nám pomáhali experti z&nbsp;projektu '"></span>
                        <a href="http://h2ospodar.cz/" target="_blank" class="result__link"><b>H2Ospodař.</b></a>
                    </p>
                </div>
                <div class="result__bottom__section">
                    <h3 class="result__subtitle">Chcete vědět, jak si vedou ostatní země?</h3>
                    <a href="https://www.waterfootprintassessmenttool.org/national-explorer/"
                       target="_blank"
                       class="btn wizard-nav-btn result__bottom__btn">Otevřít
                        mapu</a>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: "GroheResult",
    props: {
        currentTotal: {
            type: Number,
            required: true
        },
        surveyId: {
            type: String
        }
    },
    data: () => ({
        badge1: require("@/assets/illustrations/badge1.svg"),
        badge2: require("@/assets/illustrations/badge2.svg"),
        badge3: require("@/assets/illustrations/badge3.svg"),
    }),
    computed: {
        badge() {
            if (this.currentTotal < 4000) {
                return this.badge1
            }
            else if (this.currentTotal >= 4001 && this.currentTotal <= 5000) {
                return this.badge2
            }
            else {
                return this.badge3
            }
        }
    }
}
</script>

<style scoped>

</style>
